import { patchState, signalStoreFeature, withComputed, withMethods, withState } from "@ngrx/signals";
import { FilterMetadata } from '@irian-ro/abstract-resource';
import { computed } from "@angular/core";

export function withFilters<T extends {[s in keyof T]: FilterMetadata}>(initialState?:T) {
  return signalStoreFeature(
    withState<{ filters: T }>({ filters: initialState ? initialState : {} as T }),
    withComputed((store) => ({
      filtersMetadata: computed<{[key: string]: FilterMetadata }> (() => {
        const filtersObject = store.filters();
        const appliedFilters: {[key: string]: FilterMetadata } = {};
        Object.keys(filtersObject).forEach((key: string ) => {
          if (filtersObject[key as keyof T] && filtersObject[key as keyof T].value) {
            appliedFilters[key] = filtersObject[key as keyof T];
          }
        });
        return <{[key: string]: FilterMetadata }>appliedFilters;
      })
    })),
    withMethods((state) => {
      return {
        setFiltersState: (filters: T) => {
          patchState(state, {filters: {...filters}});
        },
        setFilterState: (filterMetadata: FilterMetadata, columnDef: keyof T) => {
          patchState(state, {filters: {...state.filters(), [columnDef]: filterMetadata}});
        },
        /** @deprecated Use setFiltersState instead */
        setFilersState: (filters: T) => {
          patchState(state, {filters: {...filters}});
        },
        /** @deprecated Use setFilterState instead */
        setFilerState: (filterMetadata: FilterMetadata, columnDef: keyof T) => {
          patchState(state, {filters: {...state.filters(), [columnDef]: filterMetadata}});
        },
      };
    })
  );
}
